import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authSlice";
import companyReducer from "../features/CompanySlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    company : companyReducer,
  },
});

export default store;
